import {
  Service
} from '../service.js'
import {
  env
} from '../env.js'


class TrechoBaixaPersonalizadaService extends Service {
  constructor() {
    super();

    this.url = env.url + "trecho-baixa-personalizada";
  }

  async listarReferencias(value) {
    const objetoDeFiltros = {
      "nomePadrao[iLike]":  !!value? `%${value}%` : "",
      "limit": 1000
    };
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    const referencias = await super.get(`${this.url}${queryString}`);
    return referencias;
  }

  async getReferencia(id) {
    const referencia = await super.get(`${this.url}/${id}`);
    return referencia;
  }
}

export const trechoBaixaPersonalizadaService = new TrechoBaixaPersonalizadaService()
